function getIdleEvents (route, driver, speedThreshold = 3) {
  const idleEvents = []

  const routeByDevice = route.reduce(function (a, x) {
    (a[x.deviceId] = a[x.deviceId] || []).push(x)
    return a
  }, {})

  Object.keys(routeByDevice).forEach(function (key) {
    let inIdle = false
    let last = null
    routeByDevice[key].forEach(p => {
      if (p.attributes.ignition && p.speed < speedThreshold && (!driver || p.attributes.driverUniqueId === driver.uniqueId)) {
        if (!inIdle) {
          const idleEvent = {
            position: p,
            idleTime: 0
          }
          idleEvents.push(idleEvent)
          inIdle = true
        }

        if (!idleEvents[idleEvents.length - 1].position.attributes.driverUniqueId) {
          idleEvents[idleEvents.length - 1].position.attributes.driverUniqueId = p.attributes.driverUniqueId
        }

        last = p
      } else if (inIdle) {
        const currentIdleEvent = idleEvents[idleEvents.length - 1]
        currentIdleEvent.idleTime = new Date(last.fixTime) - new Date(currentIdleEvent.position.fixTime)
        currentIdleEvent.lastPosition = last
        inIdle = false
      }
    })
  })

  return idleEvents
}

function filterPositions (positions) {
  return positions.filter(filterPosition)
}

exports.cleanPositions = (positions) => {
  return positions.map(p => {
    return {
      id: p.id,
      fixTime: p.fixTime,
      address: p.address,
      latitude: p.latitude,
      longitude: p.longitude,
      deviceId: p.deviceId,
      speed: p.speed,
      valid: p.valid
    }
  })
}

function filterPosition (p) {
  if (p.valid === false) {
    return p.attributes.ignition || p.attributes.motion
  }
  if (p.protocol === 'osmand') {
    return !(p.attributes.event >= 200 || p.attributes.event === 30)
  }
  return true
}

exports.getIdleEvents = getIdleEvents
exports.filterPositions = filterPositions
